import { z } from 'zod';
import { pagoSchema, cobrarSchema } from './ventas';
import { uuid } from './comunes';

export const ESTADOS_COBRO_TARJETA = ['pendiente', 'aprobado', 'rechazado', 'cancelado', 'expirado', 'error'] as const;
export type EstadoCobroTarjeta = (typeof ESTADOS_COBRO_TARJETA)[number];

/** Pago que admite tarjeta (solo válido en el cobro con terminal). */
export const pagoCualquieraSchema = pagoSchema.extend({
  metodo: z.enum(['efectivo', 'transferencia', 'tarjeta']),
});

/** Cobro con terminal Point: exactamente un pago de tarjeta, en MXN. */
export const cobrarTarjetaSchema = cobrarSchema
  .extend({
    pagos: z.array(pagoCualquieraSchema).max(6),
    terminalId: uuid,
  })
  .superRefine((v, ctx) => {
    const tarjetas = v.pagos.filter((p) => p.metodo === 'tarjeta');
    if (tarjetas.length !== 1) {
      ctx.addIssue({ code: 'custom', path: ['pagos'], message: 'TARJETA_UNICA' });
    }
    if (tarjetas.some((p) => p.moneda !== 'MXN')) {
      ctx.addIssue({ code: 'custom', path: ['pagos'], message: 'TARJETA_SOLO_MXN' });
    }
  });
export type CobrarTarjetaInput = z.infer<typeof cobrarTarjetaSchema>;

const alias = z.string().trim().min(1).max(40);
export const aliasTerminalSchema = z.object({ alias });
export const vincularTerminalSchema = z.object({ terminalId: z.string().trim().min(1).max(64), alias });
export const activarTerminalSchema = z.object({ activa: z.boolean() });

export interface CuentaMpVista {
  sucursalId: string;
  conectada: boolean;
  email: string | null;
  conectadaEn: string | null;
  conectadaPor: string | null;
  estado: 'activa' | 'revocada' | null;
}

export interface TerminalVista {
  id: string | null;
  terminalId: string;
  alias: string | null;
  vinculada: boolean;
  activa: boolean;
  enUso: boolean;
}

export interface CobroTarjetaVista {
  id: string;
  ventaId: string;
  terminal: { id: string; alias: string | null };
  montoMXN: number;
  estado: EstadoCobroTarjeta;
  detalleError: string | null;
  tarjeta: string | null;
  expiraEn: string;
}
